import { api } from "../../utils/api";
export async function sendRenegotiateParcels(data) {
  try {
    console.log(data);
    const response = await api.post(`installments/renegotiate_store`, data);
    return response.data;
  } catch (error) {
    return error;
  }
}
